import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showAddMessage: '=',
        list: '='
    },
    template: `
    <list-no-content ng-if="!vm.list.length" show-add-message="vm.showAddMessage"></list-no-content>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/list/empty/index.js